const popup = (($) => {
    const footerModal = document.querySelector('#footerModal')
    const seen = Cookies.get('footerModalDismiss')
    console.log(popUpExpiration)

    if (!seen) {
        setTimeout(() => {
            $(footerModal).modal('show')
        }, (popUpDelay * 1000));

        footerModal.querySelector('.close').addEventListener('click', () => {
            console.log(9)
            Cookies.set('footerModalDismiss', '1', {expires: popUpExpiration})
        })
    }

    return self
})(jQuery)

